import { get, post } from 'api';
import { CHANGELOG_URL } from 'api/routes';
import { IChangelog, IChangelogList, IChangelogPatch } from './types';

const apiPath = CHANGELOG_URL;

const createChangelogApi = () => {
  const changelog = (): Promise<IChangelogList> => get(`${apiPath}`, null, true);

  const read = (changelog: IChangelog[]) =>
    post<IChangelogPatch>(`${apiPath}read/`, { idList: changelog.map(({ id }) => id) });

  return {
    changelog,
    read,
  };
};

export default createChangelogApi();
